export default __webpack_public_path__ + "static/media/plain-sticker-L.1bbd65b5.png";